import React from "react";
import { Modal, Button } from "react-bootstrap";
import useBackButtonGuard from "hooks/useBackButtonGuard";

const BackButtonGuard = ({ active = true, message = "Are you sure you want to exit this test?" }) => {
  const { showConfirm, confirmLeave, cancelLeave } = useBackButtonGuard(active);

  return (
    <Modal show={showConfirm} size="md" centered contentClassName="mock-container browser-back-btn">
      <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
        <div className="d-flex justify-content-end align-items-center p-2">
          <button onClick={cancelLeave} className="modal-close-btn">×</button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="mock-resource-text">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="mock-test-modal-button" onClick={confirmLeave}>
          Yes, Exit
        </Button>
        <Button variant="secondary" className="mock-test-modal-button" onClick={cancelLeave}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BackButtonGuard;
